// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import SiteLayout from "./components/SiteLayout";

import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import TrustPage from "./pages/TrustPage";
import SupportPage from "./pages/SupportPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ContactPage from "./pages/ContactPage";

export default function App() {
  return (
    <Router>
      <SiteLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/company" element={<AboutPage />} />
          <Route path="/trust" element={<TrustPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* 兼容你原来的 /about */}
          <Route path="/about" element={<Navigate to="/company" replace />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SiteLayout>
    </Router>
  );
}
